<mat-form-field
  style="padding: 0; cursor: text"
  (click)="picker.open()"
  class="form-control form-control-solid form-control-datepicker date-range"
  appearance="fill"
>
<!--  <mat-label class="date-label">{{ placeholder }}</mat-label>-->
  <mat-date-range-input [formGroup]="range" [max]="maxDate" [rangePicker]="picker" class="date-pick" [class.has-separator]="showSeparator" [separator]="showSeparator ? 's/d': placeholder">
    <input class="date-pick text-black" style="cursor: text" formControlName="{{ nameStart }}" matStartDate #startDate (click)="picker.open()" />
    <input class="date-pick text-black" style="cursor: text" formControlName="{{ nameEnd }}" matEndDate #endDate (click)="picker.open()" />
  </mat-date-range-input>
  <mat-datepicker-toggle class="icon" matIconSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon>
      <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_CALENDAR"></span>
    </mat-icon>
  </mat-datepicker-toggle>
  <mat-date-range-picker #picker [calendarHeaderComponent]="dateRangePickerHeader" [disabled]="false"></mat-date-range-picker>
</mat-form-field>
